import React, { useEffect, useState } from 'react';
import crm, { STAGES } from './api';
import LeadDetail from './LeadDetail';

const AV = [['#10b981', '#0e7490'], ['#6366f1', '#8b5cf6'], ['#f59e0b', '#c99700'], ['#f43f5e', '#fb7185'], ['#0ea5e9', '#0e7490'], ['#14b8a6', '#0b6e3e']];
const grad = (n) => { const g = AV[(n || 'x').charCodeAt(0) % AV.length]; return `linear-gradient(135deg,${g[0]},${g[1]})`; };

export default function KanbanBoard() {
  const [stages, setStages] = useState([]);
  const [openId, setOpenId] = useState(null);
  const [drag, setDrag] = useState(null);
  const [over, setOver] = useState(null);

  const load = () => crm.get('/pipeline').then(({ data }) => setStages(data.stages)).catch(() => {});
  useEffect(() => { load(); }, []);

  const onDrop = async (k) => {
    setOver(null); if (!drag) return;
    const id = drag; setDrag(null);
    await crm.put(`/leads/${id}/status`, { status: k }).catch(() => {});
    load();
  };

  return (
    <div className="flex gap-4 overflow-x-auto pb-3">
      {STAGES.map((s) => {
        const col = stages.find((x) => x.key === s.key) || { leads: [], count: 0 };
        return (
          <div key={s.key}
            onDragOver={(e) => { e.preventDefault(); setOver(s.key); }} onDragLeave={() => setOver((o) => (o === s.key ? null : o))} onDrop={() => onDrop(s.key)}
            className={`w-[266px] shrink-0 rounded-2xl p-3 transition-all ${over === s.key ? 'ring-2' : ''}`}
            style={{ background: 'var(--soft)', ...(over === s.key ? { boxShadow: `inset 0 0 0 2px ${s.color}` } : {}) }}>
            <div className="flex items-center justify-between px-1 mb-3">
              <span className="flex items-center gap-2 text-[13px] font-bold" style={{ color: s.color }}><span className="w-2.5 h-2.5 rounded-full" style={{ background: s.color }} />{s.label}</span>
              <span className="text-[11px] font-bold text-white rounded-full px-2 py-0.5" style={{ background: s.color }}>{col.count}</span>
            </div>
            <div className="space-y-2.5 min-h-[100px]">
              {col.leads.map((l) => (
                <div key={l.id} draggable onDragStart={() => setDrag(l.id)} onClick={() => setOpenId(l.id)}
                  className="rounded-xl p-3 cursor-pointer surface card-lux hover:-translate-y-0.5 transition-transform">
                  <div className="flex items-center gap-2.5">
                    <div className="w-8 h-8 rounded-lg flex items-center justify-center text-white font-bold text-xs shrink-0" style={{ background: grad(l.name) }}>{(l.name || '?').slice(0, 1).toUpperCase()}</div>
                    <div className="min-w-0"><div className="font-bold text-[13px] truncate flex items-center gap-1" style={{ color: 'var(--text)' }}>{l.priority === 'hot' && <span title="Hot lead">🔥</span>}{l.name || '(no name)'}</div><div className="text-[11px] truncate" style={{ color: 'var(--muted)' }}>{l.company || '—'}</div></div>
                  </div>
                  {l.interest && <div className="text-[11px] mt-2 font-semibold" style={{ color: s.color }}>▸ {l.interest}</div>}
                  {l.value > 0 && <div className="text-[13px] font-extrabold mt-1.5" style={{ color: 'var(--text)' }}>₹{Number(l.value).toLocaleString('en-IN')}</div>}
                  <div className="flex items-center justify-between mt-2">
                    <span className="text-[10px]" style={{ color: 'var(--muted)' }}>{l.owner?.name}</span>
                    <span className="text-[9px] font-bold uppercase px-1.5 py-0.5 rounded" style={{ color: 'var(--muted)', background: 'var(--card)' }}>{l.source}</span>
                  </div>
                </div>
              ))}
              {col.leads.length === 0 && <div className="text-[11px] text-center py-6" style={{ color: 'var(--muted)' }}>Drop here</div>}
            </div>
          </div>
        );
      })}
      {openId && <LeadDetail id={openId} onClose={() => setOpenId(null)} onChanged={load} />}
    </div>
  );
}
